import styled from 'styled-components'

export const StatusTag = styled.div`
  span {
    margin: 4px 0px 0px 0px;
    padding-top: 0;
    line-height: 120%;
  }
`
